export default __webpack_public_path__ + "img/bodcURPS.94273d0a.svg";